let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22q2A")).then(() => parcelRequire('8cYfx'));